import { createContext } from 'react';
var AnnotationContext = /*#__PURE__*/createContext({});
export default AnnotationContext;